import { createQueryParams } from '@nexio/emvio-util-app';

import config from '../../config/config';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';

export const AVAILABLE_EXPORTS_LOAD = 'EXPORTS/AVAILABLE_EXPORTS_LOAD';
export const AVAILABLE_EXPORTS_SUCCESS = 'EXPORTS/AVAILABLE_EXPORTS_SUCCESS';
export const AVAILABLE_EXPORTS_FAILURE = 'EXPORTS/AVAILABLE_EXPORTS_FAILURE';
export const FETCH_BINARY_LOAD = 'EXPORTS/FETCH_BINARY_LOAD';
export const FETCH_BINARY_SUCCESS = 'EXPORTS/FETCH_BINARY_SUCCESS';
export const FETCH_BINARY_FAILURE = 'EXPORTS/FETCH_BINARY_FAILURE';
export const LARGE_EXPORTS_LOAD = 'EXPORTS/LARGE_EXPORTS_LOAD';
export const LARGE_EXPORTS_SUCCESS = 'EXPORTS/LARGE_EXPORTS_SUCCESS';
export const LARGE_EXPORT_FAILURE = 'EXPORTS/LARGE_EXPORT_FAILURE';

export const exportServiceUrl = config.exportsUrl;

export function getAvailableExports(filters, page, pageSize) {
    const queryParamsString = createQueryParams({
        page,
        pageSize
    });

    return {
        failureActionTypeOrCreator: getAvailableExportsFailureActionCreator,
        fetchParams: {
            url: `${exportServiceUrl}/getExports${queryParamsString}`
        },
        loadActionTypeOrCreator: AVAILABLE_EXPORTS_LOAD,
        successActionTypeOrCreator: getAvailableExportsSuccessActionCreator
    };
}

export function getAvailableExportsSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, AVAILABLE_EXPORTS_SUCCESS, 'exportsAvailable');
}

export function getAvailableExportsFailureActionCreator(error) {
    return {
        error,
        type: AVAILABLE_EXPORTS_FAILURE
    };
}

export function fetchExportBinary(item) {
    return {
        failureActionTypeOrCreator: fetchExportBinaryFailureActionCreator,
        fetchParams: {
            url: `${exportServiceUrl}/download/${item.guid}`
        },
        loadActionTypeOrCreator: FETCH_BINARY_LOAD,
        successActionTypeOrCreator: fetchExportBinarySuccessActionCreator
    };
}

export function fetchExportBinarySuccessActionCreator(results) {
    return {
        results,
        type: FETCH_BINARY_SUCCESS
    };
}

export function fetchExportBinaryFailureActionCreator(error) {
    return {
        error,
        type: FETCH_BINARY_FAILURE
    };
}

export function startLargeExport(merchantIds, columns, filters, sorters, dateKey, tableName, merchantMap, timezone, exportType) {
    const queryParamsString = createQueryParams({
        columns,
        dateKey,
        filters,
        merchantIds,
        sorters,
        tableName
    });

    const transformMap = columns.reduce((acc, column) => {
        acc = {
            ...acc,
            ...(column.show && {
                [column.accessor]: {
                    label: column.label,
                    transform: !!column.transformData,
                    transformType: column.transformType
                }
            })
        };

        return acc;
    }, {});

    return {
        failureActionTypeOrCreator: (error) => ({
            error,
            type: LARGE_EXPORT_FAILURE
        }),
        fetchParams: {
            url: `${exportServiceUrl}/createExportRequest${queryParamsString}`,
            method: 'POST',
            body: {
                exportType,
                timezone,
                transformMap,
                merchantMap
            }
        },
        loadActionTypeOrCreator: LARGE_EXPORTS_LOAD,
        successActionTypeOrCreator: (results) => ({
            results,
            type: LARGE_EXPORTS_SUCCESS
        })
    };
}
